import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography';
import mq from '../../../../../commons/styles/mediaQueries';
import styled from '../../../../../theme/styled';

const Dac7TabContentWrapper = styled.section`
  font-family: ${({ theme }) => theme.fonts.primary};
  background-color: ${({ theme }) => theme.colors.bgPrimary};
  padding: 16px;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  ${mq.desktop} {
    margin: 32px 0px;
    padding: 0;
  }
`;

const Dac7Fieldset = styled.fieldset`
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  > legend {
    font-weight: ${({ theme }) => theme.fontWeights.bold};
  }

  &.dac7-action-button-block {
    flex-direction: row;
    justify-content: space-between;
    padding-block: ${({ theme }) => theme.space['32']};
    ${mq.desktop} {
      border-top: ${({ theme }) => theme.borders.grey3100};
      > button {
        max-width: 177px;
      }
    }
  }

  &:disabled {
    label,
    .dac7-label {
      color: ${({ theme }) => theme.colors.grey4};
    }
  }
`;

const Dac7FormField = styled.div`
  margin-block: 12px;
`;

const Dac7HouseNumberApartmentContainer = styled.div`
  margin-top: -8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;

  > div {
    flex-grow: 1;
  }
`;

const Divider = styled.div`
  border: 1px solid #d8dfe0;
  margin-top: 20px;
  margin-bottom: 0px;
  ${mq.desktop} {
    box-sizing: border-box;
    margin-bottom: 16px;
  }
`;

const StyledRequiredFieldsText = styled(Paragraph4)`
  ${mq.desktop} {
    margin-top: 8px;
  }
`;

/**
 * This is used to prevent margin collapsed between sections.
 */
const StyledInvisibleDivider = styled.div`
  border: 1px solid white;
`;

export default {
  Dac7TabContentWrapper,
  Dac7Fieldset,
  Dac7FormField,
  Dac7HouseNumberApartmentContainer,
  Divider,
  StyledRequiredFieldsText,
  StyledInvisibleDivider,
};
